import React from "react";
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  InstapaperIcon,
  InstapaperShareButton,
  LineIcon,
  LineShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  RedditIcon,
  RedditShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton
} from "react-share";

export interface SocialShareProps {
  url: string;
}

const iconStyle = {
  bgStyle: { fill: "#1443e1" },
  iconFillColor: "#8ec1ff"
};

const SocialShare = ({ url }: SocialShareProps) => {
  const iconSize = 40;
  return (
    <div className="border-t border-lucid-800 pt-5 mt-20">
      <p className="text-sm font-bold text-lucid-300 text-center pb-1 md:text-left md:ml-5" >Share this post</p>
      <div className="flex gap-3 md:justify-center align-middle
          py-5
          px-5
          border-2
          border-lucid-700
          bg-lucid-800
          rounded-full
          md:rounded-2xl
          shadow-inner shadow-lucid-900
          overflow-x-auto
          [&>*]:drop-shadow-sm
          "
      >
        <FacebookShareButton url={url}>
          <FacebookIcon size={iconSize}
                        round={true}
                        {...iconStyle}
          />
        </FacebookShareButton>
        <TwitterShareButton url={url}>
          <TwitterIcon size={iconSize}
                       round={true}
                       {...iconStyle}
          />
        </TwitterShareButton>
        <LinkedinShareButton url={url}>
          <LinkedinIcon size={iconSize}
                        round={true}
                        {...iconStyle}
          />
        </LinkedinShareButton>
        <WhatsappShareButton url={url}>
          <WhatsappIcon size={iconSize}
                        round={true}
                        {...iconStyle}
          />
        </WhatsappShareButton>
        <LineShareButton url={url}>
          <LineIcon size={iconSize}
                    round={true}
                    {...iconStyle}
          />
        </LineShareButton>
        <RedditShareButton url={url}>
          <RedditIcon size={iconSize}
                      round={true}
                      {...iconStyle}
          />
        </RedditShareButton>
        <TelegramShareButton url={url}>
          <TelegramIcon size={iconSize}
                        round={true}
                        {...iconStyle}
          />
        </TelegramShareButton>
        <EmailShareButton url={url}>
          <EmailIcon size={iconSize}
                     round={true}
                     {...iconStyle}
          />
        </EmailShareButton>
        <InstapaperShareButton url={url}>
          <InstapaperIcon size={iconSize}
                          round={true}
                          {...iconStyle}
          />
        </InstapaperShareButton>
      </div>
    </div>
  );
};

export default SocialShare;
